<section
  class="home-alerts-widget"
  data-section-id="homeia_home_alerts"
  *ngIf="featureAvailable"
>
  <header class="ha-header">
    <h3 class="ha-title">{{ translate('home.alerts.title') }}</h3>
    <a class="ha-link" [routerLink]="alertsLink">{{ translate('home.alerts.viewAll') }}</a>
  </header>

  <ul class="ha-list" *ngIf="!loading && !error && !isEmpty; else haState">
    <li class="ha-item" *ngFor="let alert of alerts">
      <a class="ha-name" [routerLink]="alertsLink">
        <span class="ha-severity" [attr.data-sev]="alert.severity">{{ translate('alerts.severity.' + alert.severity) }}</span>
        <span class="ha-alert-title">{{ alert.title }}</span>
      </a>
      <span class="ha-status">{{ translate('alerts.status.' + alert.status) }}</span>
    </li>
  </ul>

  <ng-template #haState>
    <div class="ha-error" *ngIf="error; else haNonError">
      <p class="ha-error-message">{{ translate('home.alerts.errorMessage') }}</p>
      <button type="button" class="btn btn-outline-primary" (click)="load()">{{ translate('home.alerts.retry') }}</button>
    </div>
    <ng-template #haNonError>
      <div class="ha-empty" *ngIf="isEmpty; else haLoading">{{ translate('home.alerts.empty') }}</div>
      <ng-template #haLoading>
        <div class="ha-loading" role="status">{{ translate('home.alerts.loading') }}</div>
      </ng-template>
    </ng-template>
  </ng-template>
</section>
